 <template>
  <el-container class="home-container">
    <!-- 头部区域 -->
    <el-header>
      <!-- 单位名称（logo 区）：始终位于最左；PC 下随菜单折叠同步缩放，Pad/Mobile 下随抽屉收起/展开 -->
      <div class="logo" :class="{ 'logo-collapsed': asideHidden }" :style="logoStyle">
        <!-- 步骤 12：logo 区显示多租户单位名称（companyEntity.name，缺失时兜底平台名；居中、省略号） -->
        <span class="company-name" v-show="!asideFolded"
          :title="companyName || defaultCompanyName">{{ companyName || defaultCompanyName }}</span>
        <!-- PC 菜单折叠时：logo 区收缩为小图标占位 -->
        <i v-show="asideFolded" class="el-icon-s-grid logo-fold-icon"></i>
      </div>
      <!-- 侧边栏开关（位于单位名称右侧；PC 切换菜单折叠，Pad/Mobile 切换抽屉） -->
      <div class="menu-btn" @click="toggleMenu">
        <i :class="menuIcon"></i>
      </div>
      <!-- 系统切换菜单（步骤 11：移出 logo 深色区，置于顶栏白色区） -->
      <div class="system-switch" v-if="managementList.length > 1">
        <el-menu :default-active="activeIndex" class="el-menu-demo1" mode="horizontal"
          style="margin-left: 0; overflow: hidden;">
          <el-menu-item :index="index + ''" v-for="(item, index) in managementList" :key="index"
            @click="handleSelect(item, index)"
            :style="index == activeIndex ? 'color: var(--color-primary);font-weight: 900;' : 'background-color: var(--header-bg)'"
            style="padding: 0;margin-right:30px;">
            <span>{{ item.showName }}</span>
          </el-menu-item>
        </el-menu>
      </div>
      <!-- cpyId=110 顶栏辅助链接：统一包在容器内，靠左紧跟收缩按钮，避免 space-between 将其分散 -->
      <div class="header-links">
        <div @click="lookStep2" class="header-link" style="color:var(--text-primary);cursor:pointer;font-size:var(--font-sm);display:inline-block;margin-right:20px;"
          v-if="cpyId == 110 && hasFlag == 1 && kjkManage == 0">职工培训大屏</div>
        <div @click="lookStep3" class="header-link"
          style="color:var(--text-primary);cursor:pointer;font-size:var(--font-sm);display:inline-block;margin-right:20px;line-height:60px;"
          v-if="cpyId == 110 && manageFlag == 1 && hasFlag == 1 && kjkManage == 0">实习生轮转大屏</div>
        <div @click="lookStep4" class="header-link"
          style="color:var(--text-primary);cursor:pointer;font-size:var(--font-sm);display:inline-block;margin-right:20px;line-height:60px;"
          v-if="cpyId == 110 && manageFlag == 0 && hasFlag == 1 && kjkManage == 0">实习生轮转大屏</div>
        <div class="statusBar header-link" @click="lookStep" style="color:var(--text-primary);cursor:pointer;font-size:var(--font-sm)" v-if="cpyId == 110">操作手册
        </div>
      </div>
      <!-- 手机APP 入口暂时隐藏 -->
      <!-- <div class="app-download header-link" v-if="cpyId != 110 && cpyId != 201">
        <el-dropdown placement="bottom">
          <span class="el-dropdown-link" style="color: var(--text-regular);">
            手机APP
          </span>
          <el-dropdown-menu slot="dropdown" style="padding: 0;">
            <div class="appCode">
              <div class="statusBar_box" v-for="(item, key) in AppList" :key="key">
                <span>{{ item.name }}</span>
                <div class="statusBar_img">
                  <img :src="item.codeUrl">
                </div>
              </div>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div> -->
      <div style="flex-shrink:0;margin-right:32px;">
        <el-dropdown @command="updateStatus">
          <div class="el-dropdown-link title" style="cursor: pointer;white-space:nowrap;">
            <!--  优化没有消息的时候不显示标签0，只显示头像 -->
            <!-- <el-badge :value="totalNoRead" class="item" v-if="totalNoRead > 0">
              <img :src="avatar" alt />
            </el-badge>
            <img :src="avatar" alt v-else/> -->
            <el-badge :value="totalNoRead" class="item">
              <img :src="avatar" alt />
            </el-badge>

            <span class="user-name" style="margin-right:10px">{{ name }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item  :command="{'type': 4 }" v-if="cpyId==110">操作手册</el-dropdown-item> -->
            <el-dropdown-item :command="{ 'type': 1 }">个人资料</el-dropdown-item>
            <el-dropdown-item :command="{ 'type': 2 }">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <span>消息通知</span>
                <span class="tongzhi">{{ totalNoRead }}</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item :command="{ 'type': 3 }">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <!-- <el-menu class="el-menu-demo" mode="horizontal" pop background-color="#ffffff" text-color="#3A3A3A">
              <el-submenu index="" popper-class="submenustyle">
                <template slot="title" style="">
                  <div class="title">
                    <el-badge :value="totalNoRead" class="item">
                      <img :src="avatar" alt />
                    </el-badge>
                    <span>{{ name }}</span>
                  </div>
                </template>
                <el-menu-item @click="gouser">个人资料</el-menu-item>
                <el-menu-item @click="gomessage">
                  <div style="display: flex;justify-content: space-between;align-items: center;">
                    <span>消息通知</span>
                    <span class="tongzhi">{{ totalNoRead }}</span>
                  </div>
                </el-menu-item>
                <el-menu-item @click="logout">退出</el-menu-item>
                </el-submenu>
                </el-menu> -->

    </el-header>
    <!-- 页面区域 -->
    <el-container>
      <!-- 侧边栏（Pad / Mobile 下为抽屉） -->
      <el-aside :class="{ 'is-drawer': breakpoint !== 'pc', 'is-open': sidebarVisible }" :style="asideStyle">
        <!-- 侧边栏菜单区 -->
        <!-- <div class="toggle-button" @click="toggleCollapse">|||</div> -->
        <el-menu unique-opened
          :collapse="isCollapse" :collapse-transition="false" :router="true" :default-active="activePath">
          <!-- 一级菜单 -->
          <template v-for="(item, index) in menulist">
            <el-submenu :index="index + ''" :key="item.mid" v-if="item.subMenuList.length > 0">

              <!-- 一级菜单的模板区-->
              <template slot="title">
                <!-- 图标 -->
                <i :class="iconsObj[item.mid]"></i>
                <!-- 文本 -->
                <span>{{ item.showName }}</span>
              </template>
              <!-- 二级菜单 -->
              <el-menu-item :index="'/' + subItem.url" v-for="subItem in item.subMenuList" :key="subItem.mid"
                @click="saveNavState('/' + subItem.url)">
                <template slot="title">
                  <!-- 图标 -->
                  <i class="el-icon-menu"></i>
                  <!-- 文本 -->
                  <span>{{ subItem.showName }}</span>
                </template>
              </el-menu-item>
            </el-submenu>
            <el-menu-item :index="'/' + item.url" :key="item.mid" @click="saveNavState('/' + item.url)" v-else>
              <template slot="title">
                <!-- 文本 -->
                <span>{{ item.showName }}</span>
              </template>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>
      <!-- 右侧内容主体 -->
      <el-main>
        <pageTabs :keep-alive-component-instance="keepAliveComponentInstance" ref="pageTabs"></pageTabs>
        <div ref="keepAliveContainer">
          <keep-alive>
            <router-view :key="$route.fullPath" ref="message" :activeIndex="activeIndex"></router-view>
          </keep-alive>
        </div>
        <!-- <router-view :key="$route.fullPath" ref="message" :activeIndex="activeIndex"></router-view> -->
      </el-main>
    </el-container>
    <!-- Pad / Mobile：侧边栏抽屉遮罩 -->
    <div class="sidebar-mask" v-if="breakpoint !== 'pc' && sidebarVisible" @click="sidebarVisible = false"></div>
    <el-dialog title="管理员操作手册" :visible.sync="courseDialogVisible" width="1000px" @close="courseDialogVisible = false"
      :close-on-click-modal="false" append-to-body>
      <div class="courseware">
        <div v-for="(item, index) in chapterlist" :key="index">
          <div class="courseware_box" @click="bindpage(item, item1, index, index1)"
            :class="oneindex === index && twoindex === index1 ? 'courseware_box_ative' : ''"
            v-for="(item1, index1) in item.fileList" :key="index1">
            <div class="courseware_box_title flex-row-between">
              <div style="width:70%">{{ item.name }}</div>
            </div>
            <div class="courseware_box_center">
              <div style="display: flex;align-items: center;">
                <div class="courseware_box_center_card">{{ item1.format }}</div>
                <div class="courseware_box_center_title">{{ item1.name }}</div>
              </div>
              <div class="courseware_box_center_time" v-if="item1.format === '视频'">{{ item1.duration }}</div>
            </div>
          </div>
          <div class="courseware_box" :class="oneindex === index && twoindex === 'end' ? 'courseware_box_ative' : ''"
            v-if="item.paper !== null">
            <div class="courseware_box_title">{{ item.name }}</div>
            <div class="courseware_box_center">
              <div style="display: flex;align-items: center;">
                <div class="courseware_box_center_card">测验</div>
                <div class="courseware_box_center_title">{{ item.paper.paperName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import axios from 'axios'
import pageTabs from './TabsView/pageTabs'
export default {
  data() {
    return {
      menulist: [],// 左侧菜单数据
      iconsObj: {
        125: 'iconfont icon-user',
        103: 'iconfont icon-tijikongjian',
        101: 'iconfont icon-shangpin',
        102: 'iconfont icon-danju',
        145: 'iconfont icon-baobiao'
      },
      AppList: [],
      isCollapse: false,// 是否折叠
      activePath: '', // 被激活的链接
      avatar: '',
      name: '',
      activeIndex: '',
      managementList: [],
      sicData: [],
      websock: null, //建立的连接
      lockReconnect: false, //是否真正建立连接
      timeout: 60 * 1000, //20秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null, //断开 重连倒计时
      userId: null,
      totalNoRead: 0,
      keepAliveComponentInstance: null,
      cpyId: '',
      courseDialogVisible: false,
      chapterlist: [],
      manageFlag: 0,
      hasFlag: 0,
      kjkManage: 0,
      breakpoint: 'pc',// 当前断点：pc | pad | mobile（步骤 9）
      sidebarVisible: false,// Pad / Mobile 侧边栏抽屉是否展开
      companyName: '',// 步骤 12：多租户单位名称（companyEntity.name）
      defaultCompanyName: '医学沟通技能培训考核管理平台'// 步骤 12：companyEntity 缺失时的兜底平台名
    }
  },
  components: {
    pageTabs
  },
  computed: {
    // PC 模式：左侧菜单是否折叠为图标栏
    asideFolded() {
      return this.breakpoint === 'pc' && this.isCollapse
    },
    // Pad / Mobile：抽屉收起时 logo 完全隐藏
    asideHidden() {
      return this.breakpoint !== 'pc' && !this.sidebarVisible
    },
    // 侧边栏开关图标（PC 用折叠状态，Pad/Mobile 用抽屉状态）
    menuIcon() {
      if (this.breakpoint === 'pc') {
        return this.isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'
      }
      return this.sidebarVisible ? 'el-icon-s-fold' : 'el-icon-s-unfold'
    },
    // PC 下 logo 区宽度（折叠 64px / 展开 200px）；Pad/Mobile 交给 CSS 控制
    logoStyle() {
      if (this.breakpoint === 'pc') {
        return { width: this.isCollapse ? '64px' : 'var(--aside-width, 200px)' }
      }
      return {}
    },
    // PC 下侧边栏宽度（折叠 64px / 展开 200px）；Pad/Mobile 交给 CSS（!important 覆盖）
    asideStyle() {
      const s = { overflow: 'hidden' }
      if (this.breakpoint === 'pc') {
        s.width = this.isCollapse ? '64px' : 'var(--aside-width, 200px)'
      }
      return s
    }
  },
  mounted() {
    let user = JSON.parse(window.sessionStorage.getItem('userAccount'))
    this.cpyId = user.cpyId

    if (this.$refs.keepAliveContainer) {
      this.keepAliveComponentInstance = this.$refs.keepAliveContainer.childNodes[0].__vue__;
    }
    // 步骤 9：同步断点，监听 adaptive.js 断点切换（抽屉/顶栏状态）
    this.syncBreakpoint()
    window.addEventListener('adaptive-bpchange', this.syncBreakpoint)
  },
  beforeDestroy() {
    window.removeEventListener('adaptive-bpchange', this.syncBreakpoint)
  },
  created() {
    let _this = this;
    this.activePath = window.sessionStorage.getItem('activePath')
    this.activeIndex = window.sessionStorage.getItem('activeIndex')
    if (this.activeIndex === null || this.activeIndex === '') {
      this.activeIndex = '0'
    }

    this.getMenuList()
    this.user()
    this.getuserApp()
    document.addEventListener('visibilitychange', function () {// 用户离开了当前页面
      if (document.visibilityState === 'hidden') {
        // document.title = '页面不可见';
        _this.setUserStatus(3)
      }
      if (document.visibilityState === 'visible') {// 用户打开或回到页面
        // document.title = '页面可见';
        _this.setUserStatus(1)
      }
    });
    let user = window.sessionStorage.getItem('userAccount')
    let dataU = JSON.parse(user)
    let cpyId = user.cpyId
    this.userId = dataU.uid
    // 天门的单位id是110，不需要开启心跳
    if (cpyId != '110') {
      this.initWebSocket();
    }
    this.getcount()
    let roleList = dataU.roleList
    roleList.forEach((i) => {
      if (i == 17) {//管理部门管理员
        this.manageFlag = 1
        this.hasFlag = 1
      }
      if (i == 18) {
        this.hasFlag = 1
      }
    })
    let ridList = dataU.ridList
    let kjkManage = 0
    ridList.forEach((i) => {
      if (i == 44) {
        kjkManage = 1
      }
    })
    this.kjkManage = kjkManage
  },
  methods: {
    lookStep2() {// 职工培训大屏

      if (this.$route.query.to == '111') {// 如果是弱密码需要跳转修改密码页面
        this.$message.error('请先修改密码！')
      } else {
        const c = this.$router.resolve({
          path: '/screens',
          query: {
            id: 19
          }
        });
        window.open(c.href, "_blank");
      }
    },
    lookStep3() {// 实习生轮转大屏
      if (this.$route.query.to == '111') {// 如果是弱密码需要跳转修改密码页面
        this.$message.error('请先修改密码！')
      } else {
        const c = this.$router.resolve({
          path: '/screens',
          query: {
            id: 20
          }
        });
        window.open(c.href, "_blank");
      }
    },
    lookStep4() { // 实习生轮转大屏
      if (this.$route.query.to == '111') {// 如果是弱密码需要跳转修改密码页面
        this.$message.error('请先修改密码！')
      } else {
        const c = this.$router.resolve({
          path: '/screens',
          query: {
            id: 21
          }
        });
        window.open(c.href, "_blank");
      }
    },
    lookStep() { // 操作手册
      if (this.$route.query.to == '111') {// 如果是弱密码需要跳转修改密码页面
        this.$message.error('请先修改密码！')
      } else {
        this.getraincoursemychapterlist2()
      }
    },
    closepageTabs() {

      this.$refs.pageTabs.onClose()
    },
    updateStatus(obj) {
      if (this.$route.query.to == '111') {// 如果是弱密码需要跳转修改密码页面
        this.$message.error('请先修改密码！')
      } else {
        if (obj.type == 1) {
          this.gouser()
        }
        if (obj.type == 2) {
          this.gomessage()
        }
      }
      if (obj.type == 3) {
        this.logout()
      }


    },
    async getraincoursemychapterlist2() {
      const {
        data: res
      } = await this.$Http.traincoursemychapterlist2({
        courseId: 132
      })
      if (res.result !== 0) return this.$message.error(res.msg)
      this.chapterlist = res.data
      this.courseDialogVisible = true
    },
    bindpage(item, item1) {
      window.open(item1.resUrl, '_blank');
    },
    go(path) {
      if (path != this.$route.fullPath) {
        this.$router.push(path);
      }
    },
    async getuserApp() {
      const {
        data: res
      } = await this.$Http.userapplist()
      if (res.result != 0) {
        this.$message.error(res.msg)
        return
      }
      this.AppList = res.data
    },
    async getcount() {
      const {
        data: res
      } = await this.$Http.msglistH5({
        pageNum: 1,
        pageSize: 10
      })
      if (res.result != 0) {
        this.$message.error(res.msg)
        return
      }

      this.totalNoRead = JSON.parse(JSON.stringify(res.data.totalNoRead))
    },
    logout() {
      window.sessionStorage.clear()
      this.$router.push('/login')

      location.reload();
    },
    ce() {
      this.$router.push('/up')
    },
    handleSelect(item, index) {
      // Pad / Mobile：切换系统后收起抽屉
      if (this.breakpoint !== 'pc') this.sidebarVisible = false
      if (item.showName == '排课系统') {
        window.open('http://118.195.147.199:8089/#/login', '_blank');
        return false
      }

      //
      // this.activeIndex = index + ''
      // this.menulist = []
      // this.menulist = [...this.sicData[0], ...item.subMenuList]
      // window.sessionStorage.setItem('activeIndex', this.activeIndex)
      // this.$router.push('/home')
      this.activeIndex = index + ''
      this.menulist = []
      this.menulist = item.subMenuList
      window.sessionStorage.setItem('activeIndex', this.activeIndex)
      if (this.$route.path === '/welcome') {
        return
      }

      this.$router.push('/home')

    },
    gouser() {
      this.$router.push('/user')
    },
    gomessage() {
      this.$router.push('/message')
    },
    // 获取所有的菜单
    async getMenuList() {
      const {
        data: res
      } = await this.$Http.userMemu()
      if (res.result !== 0) return this.$message.error(res.msg)

      // if (res.data.length === 1) {
      //   let aindex = Number(this.activeIndex) + 1
      //   this.menulist = [...JSON.parse(JSON.stringify(res.data[0].subMenuList))]
      // } else {
      //   this.sicData = [JSON.parse(JSON.stringify(res.data[0].subMenuList))]
      //
      //   let aindex = Number(this.activeIndex) + 1
      //
      //   if (res.data[aindex].subMenuList.length > 0) {
      //     this.menulist = [...JSON.parse(JSON.stringify(res.data[0].subMenuList)), ...JSON.parse(JSON.stringify(res
      //       .data[aindex].subMenuList))]
      //   } else {
      //     this.menulist = [...JSON.parse(JSON.stringify(res.data[0].subMenuList))]
      //   }

      //
      //   this.managementList = JSON.parse(JSON.stringify(res.data.slice(0)));
      //   this.managementList.shift();
      //   window.sessionStorage.setItem('managementList', JSON.stringify(this.managementList))
      // }
      this.managementList = JSON.parse(JSON.stringify(res.data.slice(0)));

      let aindex = Number(this.activeIndex)
      this.menulist = JSON.parse(JSON.stringify(res.data[aindex].subMenuList))
      window.sessionStorage.setItem('managementList', JSON.stringify(this.managementList))
    },
    //设置当前用户状态
    async setUserStatus(type) {
      // const { data: res } = await this.$Http.userOnlineStatusSet({onlineStatus:type})
      // if (res.result !== 0) return this.$message.error(res.msg)
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    },
    // 侧边栏开关：PC 切换菜单折叠（图标栏），Pad/Mobile 切换抽屉
    toggleMenu() {
      if (this.breakpoint === 'pc') {
        this.isCollapse = !this.isCollapse
      } else {
        this.sidebarVisible = !this.sidebarVisible
      }
    },
    // 保存链接的激活状态
    saveNavState(activePath) {

      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
      // Pad / Mobile：点击菜单后自动收起抽屉
      if (this.breakpoint !== 'pc') this.sidebarVisible = false
    },
    // 步骤 9：同步当前断点（与 adaptive.js 阈值一致）
    syncBreakpoint() {
      const w = window.innerWidth || document.documentElement.clientWidth
      this.breakpoint = w < 768 ? 'mobile' : (w < 1280 ? 'pad' : 'pc')
      if (this.breakpoint === 'pc') this.sidebarVisible = false
    },
    // Pad / Mobile：切换侧边栏抽屉
    toggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible
    },
    async user() {
      let user = window.sessionStorage.getItem('userAccount')
      let dataU = JSON.parse(user)
      let res = await this.$Http.getUserItem({
        uid: dataU.uid
      })
      if (res.data.result != 0) {
        this.$message.error(res.data.msg)
        return
      }
      this.avatar = res.data.data.avatar
      this.name = res.data.data.name

      // 步骤 12：读取多租户单位名称（companyEntity 缺失或 name 为空时兜底显示平台名）
      const companyEntity = res.data.data.companyEntity
      this.companyName = (companyEntity && companyEntity.name) || ''

      if (this.avatar === '' || this.avatar === null) {
        this.avatar = require('@/assets/userimg.png')
      }
      if (this.name === null || this.name === '') {
        this.name = '请设置用户名'
      }
    },
    initWebSocket() {
      if (typeof WebSocket == 'undefined') {
        this.$notify({
          title: '提示',
          message: '当前浏览器无法接收实时报警信息，请使用谷歌浏览器！',
          type: 'warning',
          duration: 0
        })
        return
      }
      //建立连接
      const wsuri = axios.defaults.wsuri;//初始化weosocket
      this.websock = new WebSocket(wsuri);//建立连接
      this.websock.onopen = this.websocketonopen;//连接成功
      this.websock.onerror = this.websocketonerror;//连接错误
      this.websock.onmessage = this.websocketonmessage;//接收信息
      this.websock.onclose = this.websocketclose;//连接关闭
    },
    reconnect() { //重新连接
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function () {//新连接
        that.initWebSocket();
        that.lockReconnect = false;
      }, 5000);
    },
    reset() {
      var that = this;//重置心跳
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      that.start(); //重启心跳
    },
    start() {
      var self = this;//开启心跳
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(function () {
        //这里发送一个心跳，后端收到后，返回一个心跳消息
        if (self.websock.readyState == 1) {
          var message1 = {
            "clientMessageType": "heartbeat",
          }
          self.websock.send(JSON.stringify(message1));// 如果连接正常
        } else { //否则重连
          self.reconnect();
        }
        self.serverTimeoutObj = setTimeout(function () {//超时关闭
          this.lockReconnect = true
        }, self.timeout);
      }, self.timeout);
    },
    websocketonopen() {//连接成功事件
      var message = {
        clientMessageType: "firstMessage",
        userId: this.userId
      }
      this.websocketsend(JSON.stringify(message))
      this.start() //开启心跳
    },
    websocketonerror(e) {//连接失败事件
      ;//错误
      this.reconnect();//重连
    },
    websocketclose(e) {
      //连接关闭事件
      //提示关闭
      ;
      // //重连
      // this.websock.close();
      // this.lockReconnect = true
      this.reconnect();

    },
    async websocketonmessage(event) {
      var that = this
      this.reset();
      try {
        let data = JSON.parse(event.data)

        if (data.socketMessageType === 'unreadCount') {
          that.totalNoRead = data.unreadCount

          if (that.$route.path === '/message') {
            this.$refs.message.getUserList()
          }
        }
        if (data.socketMessageType === 'trtcUserComeIn') {
          if (this.$refs.message.refreshId == 2) {
            return false
          }
          let trtcRoomId = data.trtcRoomId
          let roomList = this.$refs.message.roomList
          let addFlag = 1
          roomList.forEach(i => {
            if (i.trtcRoomId == trtcRoomId) {
              addFlag = 0
            }
          });
          if (addFlag == 1) {
            this.$refs.message.roomList.push({
              trtcRoomId: trtcRoomId,
              type: data.type,
              name: data.name,
              contentId: data.contentId
            })
          }

        }
        //接收服务器推送的信息
        //打印收到服务器的内容
        //收到服务器信息，心跳重置

      } catch (error) {

      }
    },
    websocketsend(msg) {//向服务器发送信息
      this.websock.send(msg);
    },
    chat() {
      var msg = document.getElementById('msgContent')
      this.socket.send(msg.value)
    },
  }
}
</script>

<style lang="less" scoped>
.home-container {
  height: 100%;
}

.statusBar_box {
  width: 100%;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  text-align: center;
  background-color: #FFFFFF;

  .statusBar_img {
    display: none;
    position: absolute;
    top: 0;
    left: 185px;
    width: 200px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.statusBar_box:hover {
  background-color: #EEEEEE;
  color: #303133;

  .statusBar_img {
    // animation: op ease-in .5s;
    display: inline-block;

    animation: op ease-in .5s;

  }
}

.el-header {
  background-color: var(--header-bg);
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #fff;
  font-size: 20px;

  .logo {
    flex: none;
    width: var(--aside-width, 200px);
    height: 100%;
    background-color: var(--sidebar-bg);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    // 步骤 12：logo 区显示多租户单位名称（companyEntity.name 兜底平台名；居中 + 超长省略号）
    .company-name {
      width: 100%;
      padding: 0 12px;
      color: #fff;
      font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 1px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    // PC 菜单折叠时：logo 区收缩为小图标占位（与折叠后的菜单图标栏同宽 64px）
    .logo-fold-icon {
      font-size: 22px;
      color: #fff;
    }
  }

  .system-switch {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  /* cpyId=110 顶栏辅助链接：统一靠左、跟随收缩按钮，防止 space-between 分散按钮间距 */
  .header-links {
    display: flex;
    align-items: center;
    margin-right: auto;
    min-width: 0;

    .statusBar {
      flex: none;
    }
  }

  .statusBar {
    flex: 0.5;
    display: flex;
    justify-content: space-between;
    align-items: center;

  }

  /* 手机APP：固定在头像左侧，不参与弹性拉伸，与头像保持较大间隔，避免悬浮卡片贴边 */
  .app-download {
    flex: none;
    display: flex;
    align-items: center;
    margin-right: 60px;
    cursor: pointer;
  }

  .title {
    height: 100%;
    display: flex;
    align-items: center;

    img {
      width: 45px;
      height: 45px;
      display: inline-block;
      border-radius: 50%;
      margin-right: 20px;
    }

    /deep/ .el-badge__content.is-fixed {
      position: absolute;
      top: 16px;
      right: 30px;
    }

    /deep/ .el-badge__content {
      background-color: var(--color-danger);
      border: none;
    }

    span {
      margin-right: 25px;
      font-size: 16px;
    }

    div {
      font-size: 16px;
      cursor: pointer;
    }
  }

  /deep/ .el-submenu__title {
    display: flex;
    align-items: center;
  }
}

.tongzhi {
  border-radius: 10px;
  color: #FFF;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  background-color: var(--color-danger)
}

.el-aside {
  background-color: var(--sidebar-bg);
  box-shadow: 1px 0 6px rgba(0, 0, 0, 0.04);

  .el-menu {
    border-right: none;
  }
}

.el-main {
  background-color: var(--page-bg);
  padding: 10px;
}

.iconfont {
  margin-right: 10px;
}

.toggle-button {
  background-color: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;

}

.appCodestyle {
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
}

.appCode {
  position: relative;
  width: 180px;
  // height: 100px;
  height: 100%;
  z-index: 999;
  background-color: #eaedf1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  top: 10px;

  img {
    width: 100px;
    height: 100px;
  }
}

.el-submenu /deep/ .el-submenu__title:hover {
  background-color: var(--sidebar-hover-bg) !important;
}

.el-menu-item:hover {
  background-color: var(--sidebar-hover-bg) !important;
}

/deep/.el-menu-item {
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-menu-demo1 {
  .el-menu-item {
    color: var(--text-primary);
  }

  .el-menu-item:hover {
    background-color: var(--header-bg) !important;
  }

  /deep/ .el-submenu__title {
    display: flex;
    align-items: center;
  }

  /deep/ .is-active {
    border-bottom: 3px solid var(--color-primary) !important;
  }
}

/* ===== 步骤 9：Pad / Mobile 抽屉化与顶栏精简 ===== */
.menu-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 60px;
  color: var(--text-primary);
  font-size: 22px;
  cursor: pointer;
  flex-shrink: 0;
}

.sidebar-mask {
  position: fixed;
  top: 60px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.4);
}

// Pad / Mobile：侧边栏变抽屉（fixed + 平移隐藏）
html[data-bp='pad'] .el-aside,
html[data-bp='mobile'] .el-aside {
  position: fixed;
  top: 60px;
  bottom: 0;
  left: 0;
  z-index: 1001;
  width: var(--aside-width, 200px) !important;
  transform: translateX(-100%);
  transition: transform 0.3s ease;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);

  &.is-open {
    transform: translateX(0);
  }
}

// Pad / Mobile：单位名称（logo 区）与侧边栏菜单联动
// 抽屉收起时 logo 一并收起（宽度归零、隐藏），抽屉展开时 logo 一并展示
html[data-bp='pad'] .logo,
html[data-bp='mobile'] .logo {
  flex: none;
  width: var(--aside-width, 200px);
  overflow: hidden;
  transition: width 0.3s ease, opacity 0.3s ease;

  &.logo-collapsed {
    width: 0;
    opacity: 0;
  }
}

// Mobile：隐藏顶栏辅助链接与用户名，精简头部
html[data-bp='mobile'] .header-link {
  display: none !important;
}

html[data-bp='mobile'] .user-name {
  display: none !important;
}

// Mobile：顶栏系统切换菜单允许横向滚动（步骤 11：滚动容器随菜单移入 .system-switch）
html[data-bp='mobile'] .system-switch {
  overflow-x: auto;
  overflow-y: hidden;
}

// Pad / Mobile：顶栏系统切换菜单垂直居中，与收缩按钮 / 头像 / 用户名同一水平线
// （消除全局 .el-menu .el-menu-item 的 margin 干扰与 horizontal 菜单的 border 偏差）
html[data-bp='pad'] .system-switch .el-menu-demo1,
html[data-bp='mobile'] .system-switch .el-menu-demo1 {
  height: 100%;
  display: flex;
  align-items: center;
}

html[data-bp='pad'] .system-switch .el-menu-demo1 .el-menu-item,
html[data-bp='mobile'] .system-switch .el-menu-demo1 .el-menu-item {
  margin-top: 0;
  margin-bottom: 0;
  height: 60px;
  display: flex;
  align-items: center;
  line-height: 1;
}

html[data-bp='mobile'] .system-switch .el-menu-demo1 {
  flex-wrap: nowrap;
}

html[data-bp='mobile'] .system-switch .el-menu-demo1 .el-menu-item {
  white-space: nowrap;
}

// Pad：顶栏辅助链接间距收紧，避免挤压
html[data-bp='pad'] .header-link {
  margin-right: 12px;
}
</style>
<style lang="less">
.submenustyle {
  left: 1443px !important;
}

/* ===== 步骤 6：顶栏悬浮层对齐与美化（popper 挂载在 body 下，须非 scoped） ===== */
/* 手机APP 悬浮卡片：与触发文字居中对齐，白色圆角卡片
   （scoped 的 .appCode[data-v-x] 优先级更高，关键属性需 !important） */
.el-dropdown__popper .appCode {
  width: auto !important;
  min-width: 240px;
  padding: 14px 20px !important;
  background-color: #FFFFFF !important;
  box-shadow: 0 6px 20px rgba(6, 26, 56, 0.14) !important;
  border-radius: 10px !important;
  display: flex !important;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  position: relative;
  top: auto;

  .statusBar_box {
    width: auto !important;
    height: auto !important;
    line-height: normal !important;
    font-size: 14px;
    color: #303133;
    background-color: transparent !important;
    text-align: center;
    margin: 0 10px;
    display: flex !important;
    align-items: center;
    flex-direction: row-reverse; /* 二维码在左、名称文字在右 */
    justify-content: flex-end;
    white-space: nowrap;

    &:hover {
      color: #303133 !important;
      background-color: #F2F6FC !important;
      border-radius: 6px;

      .statusBar_img {
        display: inline-block !important;
      }
    }

    .statusBar_img {
      position: static !important;
      top: auto;
      left: auto;
      width: auto !important;
      display: none !important;
      margin-top: 0;
      margin-right: 10px; /* 二维码右侧与名称文字的间距 */

      img {
        width: 110px !important;
        height: 110px !important;
      }
    }
  }
}

/* 用户姓名下拉菜单：紧凑美观
   注：html zoom 等比缩放下 Chrome 会把弹层文本渲染成竖排，
   这里显式恢复水平书写方向（与 element-override.css 全局修复一致） */
.el-dropdown__popper .el-dropdown-menu {
  border-radius: 8px;
  padding: 6px 0;
  box-shadow: 0 6px 20px rgba(6, 26, 56, 0.12);
  writing-mode: horizontal-tb !important;
}

.el-dropdown__popper .el-dropdown-menu .el-dropdown-item {
  font-size: 14px;
  height: 38px;
  line-height: 38px;
  color: #303133;
  writing-mode: horizontal-tb !important;
  white-space: nowrap;
}

.el-dropdown__popper .el-dropdown-menu .el-dropdown-item div,
.el-dropdown__popper .el-dropdown-menu .el-dropdown-item span {
  writing-mode: horizontal-tb !important;
}

.el-dropdown__popper .el-dropdown-menu .el-dropdown-item:not(.is-disabled):hover {
  background-color: #F2F6FC;
  color: var(--color-primary);
}

.courseware {
  margin-top: 32px;
  padding: 0 48px;
}

.courseware_box {
  width: 832px;
  height: 100px;
  border-radius: 4px;
  background-color: #F8FBFF;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
  cursor: pointer;
}

.courseware_box_title {
  font-size: 16px;
  color: #122C4E;
}

.courseware_box_center {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.courseware_box_center_card {
  font-size: 12px;
  color: #7189AA;
  padding: 3px 10px;
  border: 1px dashed #7189AA;
  border-radius: 4px;
  margin-right: 12px;
}

.courseware_box_center_title {
  font-size: 14px;
  color: #7189AA;
}

.courseware_box_center_time {
  font-size: 14px;
  color: #7189AA;
}

.courseware_box_ative {
  background-color: #55B7FF !important;

  .courseware_box_title {
    color: #fff !important;
  }

  .courseware_box_center_title {
    color: #fff !important;
  }

  .courseware_box_center_time {
    color: #fff !important;
  }

  .courseware_box_center_card {
    border: 1px solid #fff !important;
    color: #fff !important;
  }
}
</style>
